import { MessageService } from "../../api/message-service";
import { EOSService } from "../../api/eos-service";

const state = {
};

const getters = {};

const actions = {
    async GetUnreadInbox(state,{perno}) {
        const params = new URLSearchParams();
        params.append('perno', perno);

        return await EOSService.makeRequest(MessageService.GetUnreadInbox(params))
    },
    async GetInbox(state) {
        var perno = state.rootState.auth.auth.username;
        const params = new URLSearchParams();
        params.append('perno', perno);

        return await EOSService.makeRequest(MessageService.GetInbox(params))
    },
    async GetForcedInboxCount(state) {
        var perno = state.rootState.auth.auth.username;
        var params = new URLSearchParams()
        params.append('perno', perno);
        return await EOSService.makeRequest(MessageService.GetForcedInboxCount(params))
    },
    async GetForcedInbox(state) {
        var perno = state.rootState.auth.auth.username;
        var params = new URLSearchParams()
        params.append('perno', perno);
        return await EOSService.makeRequest(MessageService.GetForcedInbox(params))
    },
    async GetOutbox(state) {
        var perno = state.rootState.auth.auth.username;
        var params = new URLSearchParams()
        params.append('perno', perno);
        return await EOSService.makeRequest(MessageService.GetOutbox(params))
    },
    async NewMessage(state,{params}) {
        var perno = state.rootState.auth.auth.username;
        params.append('fromid', perno);
        return await EOSService.makeRequest(MessageService.NewMessage(params))
    },
    async MarkAsRead(state, messageId) {
        var params = new URLSearchParams()
        params.append('messageId', messageId);
        return await EOSService.makeRequest(MessageService.MarkAsRead(params))
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}